import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Home, Phone } from "lucide-react";
import { SEOHead } from "@/components/SEOHead";
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <SiteLayout>
      <SEOHead
        title="Page introuvable (404)"
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        path="/404"
        noindex
      />
      <section className="min-h-[70vh] flex items-center justify-center bg-background">
        <div className="container mx-auto px-6">
          <div className="max-w-lg mx-auto text-center">
            <p className="font-heading text-8xl font-bold text-autosur-red mb-4">404</p>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-autosur-navy mb-4">
              Page introuvable
            </h1>
            <p className="font-body text-muted-foreground mb-8">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-autosur-red text-white font-heading font-semibold rounded-full hover:bg-autosur-red-light transition-colors"
              >
                <Home className="w-4 h-4" />
                Retour à l'accueil
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-autosur-navy text-white font-heading font-semibold rounded-full hover:bg-autosur-navy-light transition-colors"
              >
                <Phone className="w-4 h-4" />
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default NotFound;
